var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("Webheader.usercompany"),
        "show-filter": true,
        "show-refresh": true,
        "show-extract": true,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
        "extract-disabled": _vm.activateSpinner,
      },
      on: {
        "toggle-filter": _vm.toggleFilter,
        refresh: _vm.refreshList,
        extract: _vm.exportData,
      },
    },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("administration.user_add"),
              icon: "fa-light fa-plus",
              variant: "primary",
              size: "md",
              disabled: !_vm.canAddUser,
              "aria-label": _vm.$t("administration.user_add"),
            },
            on: { click: _vm.addUser },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filterContent" },
        [
          _c("app-panel", {
            attrs: {
              filters: _vm.filterConfig,
              searchAriaLabel:
                _vm.$t("common.srch") + " " + _vm.$t("Webheader.usercompany"),
            },
            on: {
              "filter-changed": _vm.onFilterChanged,
              "clear-filters": _vm.clearAllFilters,
              "apply-filters": _vm.applyFilter,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c("div", [
              _c(
                "section",
                { attrs: { "aria-label": "Liste des utilisateurs" } },
                [
                  _c("h2", { staticClass: "sr-only" }, [
                    _vm._v("Liste des utilisateurs"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _vm.activateSpinner
                            ? _c(
                                "div",
                                {
                                  attrs: {
                                    role: "status",
                                    "aria-live": "polite",
                                    "aria-label": _vm.$t("common.loading"),
                                  },
                                },
                                [
                                  _c("spinner"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(_vm._s(_vm.$t("common.loading"))),
                                  ]),
                                ],
                                1
                              )
                            : _vm.UsersList.length > 0
                            ? _c("b-table", {
                                staticClass: "table table-striped",
                                attrs: {
                                  responsive: "",
                                  hover: "",
                                  fields: _vm.fields,
                                  items: _vm.UsersList,
                                  selectable: _vm.UsersList.length > 0,
                                  "empty-text": _vm.$t(
                                    "common.security.no_result"
                                  ),
                                  "sort-by": _vm.sortBy,
                                  "sort-desc": _vm.sortDir,
                                },
                                on: {
                                  "update:sortBy": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sort-by": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sortDesc": function ($event) {
                                    _vm.sortDir = $event
                                  },
                                  "update:sort-desc": function ($event) {
                                    _vm.sortDir = $event
                                  },
                                  "head-clicked": _vm.sortTable,
                                  "row-selected": _vm.seeUserDetails,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(Active)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center justify-content-center",
                                          },
                                          [
                                            data.value === "0"
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa-light fa-xmark btn btn-icon btn-icon-red",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.value === "2"
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa-light fa-check btn btn-icon btn-icon-green",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.value === "1"
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa-light fa-warning btn btn-icon btn-icon-orange",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      data.value === "0"
                                                        ? _vm.$t(
                                                            "administration.no"
                                                          )
                                                        : data.value === "2"
                                                        ? _vm.$t(
                                                            "administration.yes"
                                                          )
                                                        : _vm.$t(
                                                            "administration.in_prgrss"
                                                          )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(Account)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              data.item.Rights[0].AccountName
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(delete)",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-center d-inline-block py-4 w-100",
                                            on: {
                                              click: function ($event) {
                                                return _vm.activateDelete(
                                                  $event,
                                                  data.value
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa-light fa-trash",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(data.value.IdUser)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-content-center",
                                  attrs: {
                                    role: "status",
                                    "aria-live": "polite",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "noResult" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("common.no_result")) +
                                        "\n                "
                                    ),
                                  ]),
                                ]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sr-only",
                      attrs: {
                        "aria-live": "polite",
                        "aria-atomic": "true",
                        id: "status-messages",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.statusMessage) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("cm-pagination", {
                            attrs: {
                              maxResultsByPage: _vm.paginationObject.maxResults,
                              firstIndex: _vm.paginationObject.firstIndex,
                              nbResultsTotal:
                                _vm.paginationObject.nbResultsTotal,
                              refreshEvent: _vm.paginationObject.refresh,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }